import { createSelector } from 'reselect';

import { ALERTS_REDUCER_KEY } from './alertsReducer';

export const getResourceStore = (state) => state[ALERTS_REDUCER_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const isLoading = (state) => getResourceStore(state).isLoading;
export const getError = (state) => getResourceStore(state).error;
export const getLastSyncDate = (state) => getResourceStore(state).lastSyncDate;
export const getAlerts = (state) => getResourceStore(state).resourcesById;

export const getAlertsUnread = createSelector(
  getAlerts,
  (alerts) => alerts.filter((alert) => !alert.isRead),
);

